import { createFileRoute } from '@tanstack/react-router';
import { SportEditPage } from '../pages/sports/sport-edit-page';

export const Route = createFileRoute('/sports/$id/edit')({
  component: function SportEditRoute() {
    const { id } = Route.useParams();
    return <SportEditPage sportId={id} />;
  },
});
